<template>
  <div class="career_prospect_v2">

    <div class="row list_view" v-if="showAlumniData">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
        <div class="row pg_sec" style="padding-bottom: 0px;">
          <div class="col-12 sec_content">
            <div class="row result_row" style="border-bottom: none; margin-bottom: 5px;" v-if="spotlightAlumni">
              <div class="col-12">
                <div class="row entity_detail_section">
                  <div class="col-12 title_row">
                    <span class="title ace_sec_txt" :aria-label="spotlightAlumni.title">{{spotlightAlumni.title}}{{getClassOf(spotlightAlumni)}}</span>
                  </div>
                </div>
              </div>
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
                <div class="thumbnail_container ace_sec">
                  <div class="thumbnail_img" v-if="spotlightAlumni.thumbnailURI">
                    <img v-bind:src="spotlightAlumni.thumbnailURI">
                  </div>
                  <div class="thumbnail" v-else>
                    <div class="person_thumbnail">
                      <div class="thumbnail_container">
                        <div class="default">
                          <div class="thumbnail">
                            <div class="ic thumbnail_icon icon-mentor" style="color: #787878;"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section">
                <div class="row">
                  <div class="col-12 description ace_sec_txt" id="biography" v-if="spotlightAlumni.biography">
                     <span class="desc_txt" v-html="spotlightAlumni.biography"></span>
                  </div>
                  <div class="col-12 no_description empty_pattern ace_sec_txt" v-else>
                    Biography not added
                  </div>
                  <template v-if="spotlightAlumni.biography && spotlightAlumni.biography.length > 226">
                    <div class="col-12">
                      <span class="float-right" style="cursor: pointer; color: #0645AD;" @click="expandCollapseBio" id="more-less">{{getMoreLessLabel()}}</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="row" v-if="showCareerEmoloyerJob">
              <h6><strong>Alumni Data</strong></h6>
            </div>
            <div class="row content_sec jobs_outlook national_data" v-if="showCareerEmoloyerJob">
              <div class="card col-4" v-if="alumniData && alumniData.topCareerTitle">
                <div class="card-body">
                  <template>
                    <div class="crd_data" :aria-label="'Most Popular Alumni Career ' + alumniData.topCareerTitle">
                      <div class="row">
                        <template v-if="alumniData.topCareerThumbnail">
                          <div class="col-12 text-center" style="top: -5px;">
                            <div v-if="alumniData.topCareerThumbnail">
                              <img v-bind:src="alumniData.topCareerThumbnail" style="height: 50px; width: 50px;">
                            </div>
                          </div>
                        </template>
                        <div class="col-12 text-center">
                          <h5 style="color: #6eacc8;"><strong>{{alumniData.topCareerTitle}}</strong></h5>
                        </div>
                      </div>
                    </div>
                    <div class="crd_title">
                      <span class="title_txt">
                        <span class="txt_1">Most Popular Alumni Career</span>
                     </span>
                    </div>
                  </template>
                </div>
              </div>

              <div class="card col-4" v-if="alumniData && alumniData.topCompanyTitle">
                <div class="card-body">
                  <template >
                    <div class="crd_data" :aria-label="'Company with most alumni ' + alumniData.topCompanyTitle">
                      <div class="row">
                        <div class="col-12 text-center">
                          <h5><strong>{{alumniData.topCompanyTitle}}</strong></h5>
                        </div>
                      </div>
                    </div>
                    <div class="crd_title">
                      <span class="title_txt">
                        <span class="txt_1">Company with most alumni</span>
                     </span>
                    </div>
                  </template>
                </div>
              </div>

              <div class="card col-4" v-if="alumniData && alumniData.totalHireLastYearHire" >
                <div class="card-body">
                  <template>
                    <div class="crd_data" :aria-label="'Number of hires last year ' + alumniData.totalHireLastYearHire">
                      <div class="row">
                        <div class="col-12 text-center">
                          <h5 style="color: #6eacc8;"><strong>{{alumniData.totalHireLastYearHire}}</strong></h5>
                        </div>
                      </div>
                    </div>
                    <div class="crd_title">
                      <span class="title_txt">
                        <span class="txt_1">Number of hires last year</span>
                     </span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="row float-right" v-if="showCareerEmoloyerJob">
              <span @click="navigateToSpotlightAlumni" style="cursor: pointer; color: #0645AD; font-weight: 600;">Learn about alumni companies and careers</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Filter information -->
    <div class="pg_sec" v-if="!isShowLess">
      <!--
      <div class="floating_filter_container" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled ) && ((isWidget && showCityStateFilterOnWidget) || !isWidget)">
        <b-btn @click="showFloatingFilterSection">
          <span class="ic-filter"></span>
        </b-btn>
      </div>
      -->
      <div class="row filters_section" style="margin: 20px 0px 5px 0px;">
        <div class="col-12 col-lg-12 col-md-12 col-sm-12 hd ace_sec_hd filter_hd" aria-label="Filter by State or City" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled) && ((isWidget && showCityStateFilterOnWidget) || !isWidget)">
          <!--<span class="ic icon-filter"></span>-->
          <h2>Filter by State or City</h2>
          <span class="hd_bdr"></span>
          <div class="tour_bx_container" id="filterTour"></div>
          <div class="close_floating_filter">
            <b-btn class="btn_close" @click="hideFloatingFilterSection">
              <span class="ic8-close2"></span>
            </b-btn>
          </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 filter_select_section" v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled ) && ((isWidget && showCityStateFilterOnWidget) || !isWidget)">
          <b-input-group class="row frm_sec">
            <div class="col-11 frm_fld_col">
              <div class="row">
                <div v-if="formattedGeoIdMap && formattedGeoIdMap.stateGeoIds" class="frm_fld state">
                  <label for="state">Select State</label>
                  <v-select class="select-field" :disabled="disableSelectState" v-model='selectedState'
                    :options='formattedGeoIdMap.stateGeoIds' placeholder="Select or Search for a State" :class="!selectedState ? 'no_value_selected' : ''"></v-select>
                  <span class="fld_info">
                  <span v-if="disableSelectState">To select state clear the city selection first</span>
                  </span>
                </div>
                <div class="frm_label">
                  <label>OR</label>
                </div>
                <div v-if="formattedGeoIdMap && formattedGeoIdMap.msaGeoIds" class="frm_fld city">
                  <label for="city" title="city">Select City</label>
                  <v-select class="select-field" :disabled="disableSelectMetroArea" v-model='selectedMetroArea'
                    :options='formattedGeoIdMap.msaGeoIds' placeholder="Select or Search for a City" :class="!selectedMetroArea ? 'no_value_selected' : ''"></v-select>
                  <span class="fld_info">
                  <span v-if="disableSelectMetroArea">To select city clear the state selection first</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-1 frm_btn_col">
              <b-btn @click="careerSearchClicked" aria-label="go">Go</b-btn>
            </div>
          </b-input-group>
        </div>
      </div>

      <div class="row career_prospect_tabs_container" style="margin-top: 20px;">
        <div class="col-12 career_prospect_detail">
          <template  v-if="!(isEMSIFeatureEnabled || isBGTFeatureEnabled)">
            <!-- Job Posting -->
            <div class="row pg_sec sec_job_posting" :class="selectedMetroArea ? 'city_data_selected' : ''">
              <div class="col-12">

                <div class="row">
                  <div class="col-12 hd ace_sec_hd job_posting_sec_hd" aria-label="Career Outlook">
                    <h2>Career Outlook</h2>
                    <div class="hd_bdr"></div>
                    <div class="tour_bx_container" id="careerOutlookTour"></div>
                  </div>
                  <div class="data_info_sec">
                    <span v-if="selectedCounty"> {{ selectedCounty.label }} </span>
                    <span v-else-if="selectedState"> {{ selectedState.label }} </span>
                    <span v-else-if="selectedMetroArea"> {{selectedMetroArea.label}} </span>
                    <span v-else> US National </span>
                    <span> Data </span>
                    <span> for {{majorTitle}} </span>
                  </div>
                </div>

                <div class="row content_sec jobs_outlook national_data">

                  <div class="card col-4 salary">
                    <div class="card-body">
                      <div class="crd_data">
                        <div class="crd_data_inner" v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                          <div class="ic_container">
                            <div class="ic ic8-salary"></div>
                          </div>
                          <div class="values">
                            <div class="main_val_1">
                              <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></div>
                            </div>
                            <div class="add_val" v-if="formattedCareer.aggregatedMaxIncome">
                              hi - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMaxIncome)"></span>
                            </div>
                            <div class="add_val" v-else>
                              hi - <span class="info_no_val">N/A</span>
                            </div>
                            <div class="add_val" v-if="formattedCareer.aggregatedMinIncome">
                              low - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMinIncome)"></span>
                            </div>
                            <div class="add_val" v-else>
                              low - <span class="info_no_val">N/A</span>
                            </div>
                          </div>
                       </div>
                      </div>
                      <div class="crd_title">
                        <span class="title_txt">
                          <span class="ic">
                            <span class="ic8-salary"></span>
                          </span>
                          <span class="txt">
                            <span class="txt_1">Median </span>
                            <span class="txt_2">Income</span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="card col-4">
                    <div class="card-body">
                      <template v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage">
                        <div class="crd_data" :aria-label="'Estimated Job Growth ' + formattedCareer.timeframe + ' ' + formattedCareer.aggregatedGrowthPercentage + '%'">
                          <div class="row">
                            <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
                              <div class="row legend">
                                <div class="col-6 lg_lft">0%</div>
                                <div class="col-6 lg_rgt">15%</div>
                              </div>
                              <div class="gph_chart gph_pie_chart">
                                <doughnut-chart :chart-data="growthPieData" id="gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('gauge', formattedCareer.aggregatedGrowthPercentage)"></doughnut-chart>
                              </div>
                            </div>
                            <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val">
                              <span class="val_1_txt" v-html="(Math.round(formattedCareer.aggregatedGrowthPercentage * 100) / 100).toFixed(1)"></span><span>%</span>
                            </div>
                          </div>
                        </div>
                        <div class="crd_title">
                          <span class="title_txt">
                            <span class="txt_1">Estimated Job Growth </span>
                            <span class="txt_2">{{formattedCareer.timeframe}}</span>
                         </span>
                        </div>
                      </template>
                    </div>
                  </div>

                  <div class="card col-4 postings">
                    <div class="card-body">
                      <div class="crd_data">
                        <div class="crd_data_inner" v-if="formattedCareer && formattedCareer.aggregatedLastYearJob" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(formattedCareer.aggregatedLastYearJob)">
                          <div class="ic_container">
                            <div class="ic ic8-job2"></div>
                          </div>
                          <div class="values">
                            <div class="main_val_1">
                              <span class="val_1_txt" v-html="formatNumericVal(formattedCareer.aggregatedLastYearJob)"></span>
                            </div>
                          </div>
                       </div>
                      </div>
                      <div class="crd_title">
                        <span class="title_txt">
                          <span class="ic">
                            <span class="ic8-job2"></span>
                          </span>
                          <span class="txt">
                            <span class="txt_1">Job Postings </span>
                            <span class="txt_2">2023 - 2033</span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <!-- ## end job outlook ## -->
            </div>
            <!-- End Job Posting -->

            <!-- Careers -->
            <div class="row pg_sec sec_career" v-if="!isShowLess">
              <div class="col-12 hd ace_sec" aria-label="Career Options" style="margin-bottom: 0px;">
                <!-- custom career chart -->
                <div class="row pg_sec career_chart_container">
                  <div class="col-11">
                    <div style="float: left; width: 162px;">
                      <h2 aria-label="Careers">Top Careers</h2>
                      <span class="hd_bdr"></span>
                      <div class="tour_bx_container" id="topCareersTour"></div>
                    </div>
                    <div class="ace_sec_hd lnk_sec" style="float: left; margin-top: 7px;">
                      <template v-if="showAllOccupations">
                        <b-link @click="toggleShowOccupations()">Show Careers At Your Program Level</b-link>
                      </template>
                      <template v-if="!showAllOccupations">
                        <b-link @click="toggleShowOccupations()">Show All Careers</b-link>
                      </template>
                    </div>
                  </div>
                  <div class="col-12 ace_sec" aria-label="Careers Chart">

                    <div class="bar_chart_container bar_label_inside">
                      <template>
                        <div class="accordion acrdn_top_careers" role="tablist">

                            <template v-for="(formattedCareerOcc, index) in targetOccupationItems">
                              <div class="row bar_row ace_sec">
                                <div class="col-12">

                                  <b-card no-body>
                                    <b-card-header header-tag="header" class="row_hd" role="tab">
                                      <b-button block v-b-toggle="'acrdnTopCareer_' + index" variant="info">
                                        <span class="btn_txt">{{ formattedCareerOcc.Occupation }}</span>
                                        <span class="ic ic8-circle-up"></span>
                                        <span class="ic ic8-circle-down"></span>
                                      </b-button>
                                    </b-card-header>
                                    <b-collapse :visible="index === 0" :id="'acrdnTopCareer_' + index" accordion="careers-accordion" role="tabpanel">
                                      <b-card-body>

                                        <div class="row">
                                          <!--
                                          <div class="col-2"></div>
                                          -->
                                          <div class="col-10 title" style="margin-left: 20px;">
                                             <span @click="navigateToCareer(formattedCareerOcc)">{{ formattedCareerOcc.Occupation }}</span>
                                          </div>
                                        </div>

                                        <div class="row content_sec jobs_outlook">

                                          <div class="card col-4 salary">
                                            <div class="card-body">
                                              <div class="crd_data">
                                                <div class="crd_data_inner">
                                                  <div class="ic_container">
                                                    <div class="ic ic8-salary"></div>
                                                  </div>
                                                  <div class="values">
                                                    <div class="main_val_1">
                                                      <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(formattedCareerOcc['Median Earnings'])"></div>
                                                    </div>
                                                    <div class="add_val" v-if="formattedCareerOcc.aggregatedMaxIncome">
                                                      hi - $<span v-html="addCommaInNumber(formattedCareerOcc.aggregatedMaxIncome)"></span>
                                                    </div>
                                                    <div class="add_val" v-else>
                                                      hi - <span class="info_no_val">N/A</span>
                                                    </div>
                                                    <div class="add_val" v-if="formattedCareerOcc.aggregatedMinIncome">
                                                      low - $<span v-html="addCommaInNumber(formattedCareerOcc.aggregatedMinIncome)"></span>
                                                    </div>
                                                    <div class="add_val" v-else>
                                                      low - <span class="info_no_val">N/A</span>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="crd_title">
                                                <span class="title_txt">
                                                  <span class="ic">
                                                    <span class="ic8-salary"></span>
                                                  </span>
                                                  <span class="txt">
                                                    <span class="txt_1">Median </span>
                                                    <span class="txt_2">Income</span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="card col-4">
                                            <div class="card-body">
                                              <template>
                                                <div class="crd_data" :aria-label="'Estimated Job Growth ' + formattedCareerOcc.timeframe + ' ' + formattedCareerOcc.growth + '%'">
                                                  <div class="row">
                                                    <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
                                                      <div class="row legend">
                                                        <div class="col-6 lg_lft">0%</div>
                                                        <div class="col-6 lg_rgt">15%</div>
                                                      </div>
                                                      <div class="gph_chart gph_pie_chart">
                                                        <doughnut-chart :chart-data="growthPieData"  :id="'cos-gauge-' + index" :options="growthPieOptions" @afterComplete="callDrawNeedle('cos-gauge-' + index, formattedCareerOcc.growth)"></doughnut-chart>
                                                      </div>
                                                    </div>
                                                    <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val">
                                                      <span class="val_1_txt" v-html="(Math.round((formattedCareerOcc.growth) * 100) / 100).toFixed(1)"></span><span>%</span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="crd_title">
                                                  <span class="title_txt">
                                                    <span class="txt_1">Estimated Job Growth </span>
                                                    <span class="txt_2">{{formattedCareerOcc.timeframe}}</span>
                                                 </span>
                                                </div>
                                              </template>
                                            </div>
                                          </div>

                                          <div class="card col-4 postings">
                                            <div class="card-body">
                                              <div class="crd_data">
                                                <div class="crd_data_inner">
                                                  <div class="ic_container">
                                                    <div class="ic ic8-job2"></div>
                                                  </div>
                                                  <div class="values">
                                                    <div class="main_val_1">
                                                      <span class="val_1_txt" v-html="formatNumericVal(formattedCareerOcc['2010 Jobs'])"></span>
                                                    </div>
                                                  </div>
                                               </div>
                                              </div>
                                              <div class="crd_title">
                                                <span class="title_txt">
                                                  <span class="ic">
                                                    <span class="ic8-job2"></span>
                                                  </span>
                                                  <span class="txt">
                                                    <span class="txt_1">Job Postings </span>
                                                    <span class="txt_2">2023 - 2033</span>
                                                  </span>
                                                </span>
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                        <!-- ## end top career row ## -->

                                        <div class="bar_container jobs">
                                          <div class="bar_content">
                                            <div class="row edu_label" v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                                              <div class="col-12 hd">
                                                Education Level
                                              </div>
                                              <div class="col-12 tags_row">
                                                <template v-for="edu in formattedCareerOcc['Education'] ">
                                                  <div class="tag ace_sec_txt" v-if="edu.score > 0">
                                                    <span class="edu_level" :class="'edu_' + edu.level.charAt(0)" :title="edu.level">
                                                    {{edu.level.charAt(0)}}
                                                    </span>
                                                    <span class="edu_score"><span v-html="formatNumericVal(edu.score)"></span>%</span>
                                                  </div>
                                                </template>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>

                                </div>
                              </div>
                            </template>

                        </div>
                      </template>

                    </div>

                  </div>
                </div>

              </div>
            </div>
            <!-- End Careers -->
          </template>

          <b-card no-body v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled)">

            <!-- .tabs -->
            <div class="tab_content_section">
              <div class="tab_content_container">
                <div class="tab_content active" id="tabPan_Jobs">
                  <div class="tab_info" v-if="isWidget && !unlockCompaniesSkillsOnWidget">
                    Click on companies or skills to unlock more details
                  </div>
                  <!-- Job Posting -->
                  <div class="row pg_sec sec_job_posting" :class="selectedMetroArea ? 'city_data_selected' : ''">
                    <div class="col-12">

                    <div class="row">
                      <div class="col-12 hd ace_sec_hd job_posting_sec_hd" aria-label="Career Outlook">
                        <h2>Career Outlook</h2>
                        <span class="hd_bdr"></span>
                        <div class="tour_bx_container" id="careerOutlookTour"></div>
                      </div>
                      <div class="data_info_sec">
                        <span> {{selectedDataInfo}} Data </span>
                      </div>
                    </div>


                      <div class="row content_sec jobs_outlook national_data">

                        <div class="card col-4 salary">
                          <div class="card-body">
                            <div class="crd_data">
                              <div class="crd_data_inner" v-if="formattedCareer && formattedCareer.aggregatedMedianHourlyEarning" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                                <div class="ic_container">
                                  <div class="ic ic8-salary"></div>
                                </div>
                                <div class="values">
                                  <div class="main_val_1">
                                    <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></div>
                                  </div>
                                  <div class="add_val" v-if="formattedCareer.aggregatedMaxIncome">
                                    hi - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMaxIncome)"></span>
                                  </div>
                                  <div class="add_val" v-else>
                                    hi - <span class="info_no_val">N/A</span>
                                  </div>
                                  <div class="add_val" v-if="formattedCareer.aggregatedMinIncome">
                                    low - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMinIncome)"></span>
                                  </div>
                                  <div class="add_val" v-else>
                                    low - <span class="info_no_val">N/A</span>
                                  </div>
                                </div>
                             </div>
                            </div>
                            <div class="crd_title">
                              <span class="title_txt">
                                <span class="ic">
                                  <span class="ic8-salary"></span>
                                </span>
                                <span class="txt">
                                  <span class="txt_1">Median </span>
                                  <span class="txt_2">Income</span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="card col-4">
                          <div class="card-body">
                            <template v-if="formattedCareer && formattedCareer.aggregatedGrowthPercentage">
                              <div class="crd_data" :aria-label="'Estimated Job Growth ' + formattedCareer.timeframe + ' ' + formattedCareer.aggregatedGrowthPercentage + '%'">
                                <div class="row">
                                  <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
                                    <div class="row legend">
                                      <div class="col-6 lg_lft">0%</div>
                                      <div class="col-6 lg_rgt">15%</div>
                                    </div>
                                    <div class="gph_chart gph_pie_chart">
                                      <doughnut-chart :chart-data="growthPieData" id="gauge" :options="growthPieOptions" @afterComplete="callDrawNeedle('gauge', formattedCareer.aggregatedGrowthPercentage)"></doughnut-chart>
                                    </div>
                                  </div>
                                  <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val">
                                    <span class="val_1_txt" v-html="(Math.round(formattedCareer.aggregatedGrowthPercentage * 100) / 100).toFixed(1)"></span><span>%</span>
                                  </div>
                                </div>
                              </div>
                              <div class="crd_title">
                                <span class="title_txt">
                                  <span class="txt_1">Estimated Job Growth </span>
                                  <span class="txt_2">{{formattedCareer.timeframe}}</span>
                               </span>
                              </div>
                            </template>
                          </div>
                        </div>

                        <div class="card col-4 postings">
                          <div class="card-body">
                            <div class="crd_data">
                              <div class="crd_data_inner" v-if="formattedCareer && formattedCareer.aggregatedLastYearJob" :aria-label="'job postings in the last 12 months ' + addCommaInNumber(formattedCareer.aggregatedLastYearJob)">
                                <div class="ic_container">
                                  <div class="ic ic8-job2"></div>
                                </div>
                                <div class="values">
                                  <div class="main_val_1">
                                    <span class="val_1_txt" v-html="formatNumericVal(formattedCareer.aggregatedLastYearJob)"></span>
                                  </div>
                                </div>
                             </div>
                            </div>
                            <div class="crd_title">
                              <span class="title_txt">
                                <span class="ic">
                                  <span class="ic8-job2"></span>
                                </span>
                                <span class="txt">
                                  <span class="txt_1">Job Postings </span>
                                  <span class="txt_2">2023 - 2033</span>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <!-- ## end job outlook ## -->

                  </div>
                  <!-- End Job Posting -->
                  <!-- Careers -->
                  <div class="row pg_sec sec_career" v-if="!isShowLess">
                    <div class="col-12 hd ace_sec" aria-label="Career Options" style="margin-bottom: 0px;">
                      <!-- custom career chart -->
                      <div class="row pg_sec career_chart_container">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12 hd ace_sec_hd" aria-label="Carrers">
                              <div class="row">

                                <div class="col-11">
                                  <div style="float: left; width: 162px;">
                                    <h2 aria-label="Careers">Top Careers</h2>
                                    <div class="tour_bx_container" id="topCareersTour"></div>
                                  </div>
                                  <div class="ace_sec_hd lnk_sec" style="float: left; margin-top: 7px;">
                                    <template v-if="showAllOccupations">
                                      <b-link @click="toggleShowOccupations()">Show Careers At Your Program Level</b-link>
                                    </template>
                                    <template v-if="!showAllOccupations">
                                      <b-link @click="toggleShowOccupations()">Show All Careers</b-link>
                                    </template>
                                  </div>
                                </div>

                                <div class="col-1">
                                  <template v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                                    <div class="row" style="margin-bottom: 10px;">

                                      <div class="col-2 tags_legend">
                                        <div class="tags_legend_icon" id="popoverTarget2_eduLevelTags" style="margin-top: -5px;">
                                          <div class="ic ic8-info5"></div>
                                        </div>
                                        <b-popover ref="educationLevelTagsLagends" target="popoverTarget2_eduLevelTags" triggers="click" placement="bottom" class="chart_tooltip_popover" container="eduLevelTagsLagends">
                                          <div class="tooltip_row tag_skill tag_edu_level">
                                            <div class="popup_hd row">
                                              <div class="hd_txt col-11">
                                                Legend
                                              </div>
                                              <div class="btn_container col-1">
                                                <button class="btn_close" aria-label="close" @click="closeEducationLevelTagsLegendsPopup">
                                                <span class="ic8-close2"></span>
                                                </button>
                                              </div>
                                            </div>
                                            <div class="edu_tag_row">
                                              <div class="tag ace_sec_txt edu_H">H</div>
                                              <div class="tag_detail">
                                                High School or Vocational Training
                                              </div>
                                            </div>
                                            <div class="edu_tag_row">
                                              <div class="tag ace_sec_txt edu_C">C</div>
                                              <div class="tag_detail">
                                                Post Secondary Diploma or Certificate
                                              </div>
                                            </div>
                                            <div class="edu_tag_row">
                                              <div class="tag ace_sec_txt edu_A">A</div>
                                              <div class="tag_detail">
                                                Associate's Degree
                                              </div>
                                            </div>
                                            <div class="edu_tag_row">
                                              <div class="tag ace_sec_txt edu_B">B</div>
                                              <div class="tag_detail">
                                                Bachelor's Degree
                                              </div>
                                            </div>
                                            <div class="edu_tag_row">
                                              <div class="tag ace_sec_txt edu_M">M</div>
                                              <div class="tag_detail">
                                                Master's Degree
                                              </div>
                                            </div>
                                            <div class="edu_tag_row">
                                              <div class="tag ace_sec_txt edu_D">D</div>
                                              <div class="tag_detail">
                                                Doctorate's Degree
                                              </div>
                                            </div>
                                          </div>
                                        </b-popover>
                                        <div id="eduLevelTagsLagends" class="chart_tooltip_popover"></div>
                                      </div>
                                    </div>
                                  </template>
                                </div>

                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-12 ace_sec" aria-label="Careers Chart">
                              <!--
                              <div class="avg_val ace_sec_txt" :aria-label="'Median Income $ ' + addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)">
                                <span class="avg_val_txt">
                                Median Income - $<span v-html="addCommaInNumber(formattedCareer.aggregatedMedianHourlyEarning)"></span>
                                </span>
                              </div>
                              <div class="avg_val_connecter"></div>
                              -->
                              <div class="bar_chart_container bar_label_inside">
                                <template>
                                  <div class="accordion acrdn_top_careers" role="tablist">

                                      <template v-for="(formattedCareerOcc, index) in targetOccupationItems">
                                        <div class="row bar_row ace_sec">
                                          <div class="col-12">

                                            <b-card no-body>
                                              <b-card-header header-tag="header" class="row_hd" role="tab">
                                                <b-button block v-b-toggle="'acrdnTopCareer_' + index" variant="info">
                                                  <span class="btn_txt">{{ formattedCareerOcc.Occupation }}</span>
                                                  <span class="ic ic8-circle-up"></span>
                                                  <span class="ic ic8-circle-down"></span>
                                                </b-button>
                                              </b-card-header>
                                              <b-collapse :visible="index === 0" :id="'acrdnTopCareer_' + index" accordion="careers-accordion" role="tabpanel">
                                                <b-card-body>

                                                  <div class="row">
                                                    <div class="col-10 title" style="margin-left: 20px;">
                                                       <span @click="navigateToCareer(formattedCareerOcc)">{{ formattedCareerOcc.Occupation }}</span>
                                                    </div>
                                                  </div>

                                                  <div class="row content_sec jobs_outlook">

                                                    <div class="card col-4 salary">
                                                      <div class="card-body">
                                                        <div class="crd_data">
                                                          <div class="crd_data_inner">
                                                            <div class="ic_container">
                                                              <div class="ic ic8-salary"></div>
                                                            </div>
                                                            <div class="values">
                                                              <div class="main_val_1">
                                                                <div class="val_1_txt salary" v-html="'$' + addCommaInNumber(formattedCareerOcc['Median Earnings'])"></div>
                                                              </div>
                                                              <div class="add_val" v-if="formattedCareerOcc.aggregatedMaxIncome">
                                                                hi - $<span v-html="addCommaInNumber(formattedCareerOcc.aggregatedMaxIncome)"></span>
                                                              </div>
                                                              <div class="add_val" v-else>
                                                                hi - <span class="info_no_val">N/A</span>
                                                              </div>
                                                              <div class="add_val" v-if="formattedCareerOcc.aggregatedMinIncome">
                                                                low - $<span v-html="addCommaInNumber(formattedCareerOcc.aggregatedMinIncome)"></span>
                                                              </div>
                                                              <div class="add_val" v-else>
                                                                low - <span class="info_no_val">N/A</span>
                                                              </div>
                                                            </div>
                                                         </div>
                                                        </div>
                                                        <div class="crd_title">
                                                          <span class="title_txt">
                                                            <span class="ic">
                                                              <span class="ic8-salary"></span>
                                                            </span>
                                                            <span class="txt">
                                                              <span class="txt_1">Median </span>
                                                              <span class="txt_2">Income</span>
                                                            </span>
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div class="card col-4">
                                                      <div class="card-body">
                                                        <template>
                                                          <div class="crd_data" :aria-label="'Estimated Job Growth ' + formattedCareerOcc.timeframe + ' ' + formattedCareerOcc.growth + '%'">
                                                            <div class="row">
                                                              <div class="col-xl-7 col-lg-6 col-md-12 col-sm-12 chart_container">
                                                                <div class="row legend">
                                                                  <div class="col-6 lg_lft">0%</div>
                                                                  <div class="col-6 lg_rgt">15%</div>
                                                                </div>
                                                                <div class="gph_chart gph_pie_chart">
                                                                  <doughnut-chart :chart-data="growthPieData" :id="'bgt-gauge-' + index" :options="growthPieOptions" @afterComplete="callDrawNeedle('bgt-gauge-' + index, formattedCareerOcc.growth)"></doughnut-chart>
                                                                </div>
                                                              </div>
                                                              <div class="col-xl-5 col-lg-6 col-md-12 col-sm-12 main_val_1 gph_val">
                                                                <span class="val_1_txt" v-html="(Math.round((formattedCareerOcc.growth) * 100) / 100).toFixed(1)"></span><span>%</span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="crd_title">
                                                            <span class="title_txt">
                                                              <span class="txt_1">Estimated Job Growth </span>
                                                              <span class="txt_2">{{formattedCareerOcc.timeframe}}</span>
                                                           </span>
                                                          </div>
                                                        </template>
                                                      </div>
                                                    </div>

                                                    <div class="card col-4 postings">
                                                      <div class="card-body">
                                                        <div class="crd_data">
                                                          <div class="crd_data_inner">
                                                            <div class="ic_container">
                                                              <div class="ic ic8-job2"></div>
                                                            </div>
                                                            <div class="values">
                                                              <div class="main_val_1">
                                                                <span class="val_1_txt" v-html="formatNumericVal(formattedCareerOcc['2010 Jobs'])"></span>
                                                              </div>
                                                            </div>
                                                         </div>
                                                        </div>
                                                        <div class="crd_title">
                                                          <span class="title_txt">
                                                            <span class="ic">
                                                              <span class="ic8-job2"></span>
                                                            </span>
                                                            <span class="txt">
                                                              <span class="txt_1">Job Postings </span>
                                                              <span class="txt_2">2023 - 2033</span>
                                                            </span>
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </div>

                                                  </div>
                                                  <!-- ## end top career row ## -->

                                                  <div class="bar_container jobs">
                                                    <div class="bar_content">
                                                      <div class="row edu_label" v-if="(showEducationLevelEnabled && !isWidget) || (isWidget && showEducationLevelOnWidgetEnabled)">
                                                        <div class="col-12 hd">
                                                          Education Level
                                                        </div>
                                                        <div class="col-12 tags_row">
                                                          <template v-for="edu in formattedCareerOcc['Education'] ">
                                                            <div class="tag ace_sec_txt" v-if="edu.score > 0">
                                                              <span class="edu_level" :class="'edu_' + edu.level.charAt(0)" :title="edu.level">
                                                              {{edu.level.charAt(0)}}
                                                              </span>
                                                              <span class="edu_score"><span v-html="formatNumericVal(edu.score)"></span>%</span>
                                                            </div>
                                                          </template>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>

                                                </b-card-body>
                                              </b-collapse>
                                            </b-card>

                                          </div>
                                        </div>
                                      </template>

                                  </div>
                                </template>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- custom career chart -->
                    </div>
                  </div>
                  <!-- End Careers -->
                </div>
                <!-- .tab_content -->

                <div v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled) && ((isWidget && unlockCompaniesSkillsOnWidget) || !isWidget)">
                  <!-- Top Companies -->
                  <div class="row pg_sec" v-if="!isShowLess" style="margin-top: 50px;">
                    <div class="col-12 hd ace_sec tree_map" aria-label="Top companies that hire" style="margin-bottom: 0px;">
                      <div class="tree_map_heading">
                        <h2>Top Companies by Number of Job Postings</h2>
                        <div class="tour_bx_container" id="topCompaniesTour"></div>
                      </div>
                      <div class="tree_map_container" style="margin-top: -4px;">
                        <!--
                          <tree-map-chart :jsonData="companiesTreeMapData"></tree-map-chart>
                          -->
                        <div class="col-12 gph_sec ace_sec" aria-label="Top Companies Posting Chart">
                          <div class="row time_chart_container chart_companies_posting">
                            <!--
                              ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
                              need to make it configurable under admin settings to update the size of chart
                              -->
                            <template v-for="(topCompaniesItems, index) in topCompaniesItems">
                              <div class="col-12 bar_block ace_sec">
                                <b-popover :target="'popoverTarget_' + index" triggers="hover" placement="top" class="tooltip_popover" container="companiesPostingToolTip">
                                  <div class="tooltip_row">
                                    <div class="hd_txt"><span class="hd_txt" v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
                                  </div>
                                  <div class="tooltip_row">
                                    <div class="label"> Postings</div>
                                    <div class="val"><span v-html="formatNumericVal(topCompaniesItems.Total)"></span></div>
                                  </div>
                                  <!--
                                    <div class="tooltip_row">
                                      <div class="val"><span v-html="addCommaInNumber(topCompaniesItems.Unique)"></span></div>
                                      <div class="label">Unique Postings</div>
                                    </div>
                                    -->
                                </b-popover>
                                <div id="companiesPostingToolTip" class="chart_tooltip_popover"></div>
                                <div class="bar_block_inner" :id="'popoverTarget_' + index">
                                  <div class="row">
                                    <div class="col-12 bar_title"><span v-html="checkForCompanyName(topCompaniesItems.Company)"></span></div>
                                    <div class="col-12 bar_val_1">Postings <span v-html="formatNumericVal(topCompaniesItems.Total)"></span></div>
                                  </div>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Top Companies -->
                </div>
                <!-- .tab_content -->

                <div v-if="(isEMSIFeatureEnabled || isBGTFeatureEnabled) && ((isWidget && unlockCompaniesSkillsOnWidget) || !isWidget)">
                  <!-- Top Skills -->
                  <div class="row pg_sec" v-if="!isShowLess" style="margin-top: 50px;">
                    <div class="col-12 hd ace_sec tree_map" aria-label="Top skills">
                      <div class="row tree_map_heading skills_tab_heading">
                        <div class="col-10 hd_txt">
                          <h2>Top In-Demand Skills within Job Postings</h2>
                          <div class="tour_bx_container" id="skillsTour"></div>
                        </div>
                        <div class="col-2 tags_legend">
                          <div class="tags_legend_icon" id="popoverTarget2_skillTags">
                            <div class="ic ic8-info5"></div>
                          </div>
                          <b-popover ref="skillTagsLegendsPopover" target="popoverTarget2_skillTags" triggers="click" placement="bottom" class="chart_tooltip_popover" container="skillsTagsLagends">
                            <div class="tooltip_row tag_skill">
                              <div class="popup_hd row">
                                <div class="hd_txt col-11">
                                  Types of Skills
                                </div>
                                <div class="btn_container col-1">
                                  <button class="btn_close" aria-label="close" @click="closeSkillTagsLegendsPopup">
                                  <span class="ic8-close2"></span>
                                  </button>
                                </div>
                              </div>
                              <div class="skill_tag_row">
                                <div class="tag ace_sec_txt baselineSkills">F</div>
                                <div class="tag_detail">
                                  <span class="tag_type_title">Foundational Skill:</span>
                                  Important skills that cross industries and occupations, such as organizational skills, communication skills, and project management, etc
                                </div>
                              </div>
                              <!--
                                <span class="skill_tag_row">
                                  <span class="tag ace_sec_txt definingSkills">D</span> Defining Skill
                                </span>
                                <span class="skill_tag_row">
                                  <span class="tag ace_sec_txt necessarySkills">N</span> Necessary Skill
                                </span>
                                -->
                              <div class="skill_tag_row">
                                <div class="tag ace_sec_txt specializedSkills">S</div>
                                <div class="tag_detail">
                                  <span class="tag_type_title">Specialized Skill:</span>
                                  Occupation-specific skills identified in job postings, such as accounting, python programming, informatics, cybersecurity, etc.
                                </div>
                              </div>
                              <div class="skill_tag_row">
                                <div class="tag ace_sec_txt salaryBoostSkills">$</div>
                                <div class="tag_detail">
                                  <span class="tag_type_title">Salary Boost Skill:</span>
                                  High demand skills that may provide a salary boost in an occupation
                                </div>
                              </div>
                              <!--
                                <span class="skill_tag_row">
                                  <span class="tag ace_sec_txt distinguishingSkills" style="width: 38px;">Dis</span> Distinguishing Skill
                                </span>
                                -->
                            </div>
                          </b-popover>
                          <div id="skillsTagsLagends" class="chart_tooltip_popover"></div>
                        </div>
                      </div>
                      <div class="tree_map_container chart_skills" id="careerDetailsSkills" style="margin-top: 20px;">
                        <!--
                          <tree-map-chart :jsonData="skillsTreeMapData"></tree-map-chart>
                          -->
                        <div class="row" v-if="isBGTFeatureEnabled">
                          <template v-if="isSalaryBoostSkill">
                            <div class="col-12 lnk_skill">
                              <div class="lnk_boost_skills">
                                <b-link @click="showSalaryBoostSkills">Show Salary Boost Skills</b-link>
                              </div>
                              <div class="lnk_all_skills">
                                <b-link @click="showAllSkills">Show All Skills</b-link>
                              </div>
                            </div>
                          </template>
                        </div>
                        <div class="col-12 gph_sec ace_sec" aria-label="Top Companies Posting Chart">
                          <div class="row time_chart_container chart_skills">
                            <!--
                              ToDo - Neeraj [07 Feb 2020]: Limit the result size upto 10 by chart.scss file for now,
                              need to make it configurable under admin settings to update the size of chart
                              -->
                            <template v-for="(topSkillsItems, index) in topSkillsItems">
                              <div class="col-12 bar_block ace_sec"
                                :class="'bar_block_' + index + ' ' + topSkillsItems.Types"
                                :aria-label="topSkillsItems.Postings_with_Skill + ' Postings in ' + topSkillsItems.Skill">
                                <b-popover :target="'popoverTarget2_' + index" triggers="hover" placement="top" class="chart_tooltip_popover" container="skillsToolTip">
                                  <div class="tooltip_row">
                                    <div class="label">Skill</div>
                                    <div class="val">{{topSkillsItems.Skill}}</div>
                                  </div>
                                  <div class="tooltip_row">
                                    <div class="label">Postings</div>
                                    <div class="val"><span v-html="formatNumericVal(topSkillsItems.Postings_with_Skill)"></span></div>
                                  </div>
                                  <div class="tooltip_row tag_skill">
                                    <template v-for="type in topSkillsItems.Types">
                                      <span v-if="type === 'baselineSkills'" class="skill_tag_row">
                                      <span class="tag ace_sec_txt" :class="type">F</span> Foundational Skill
                                      </span>
                                      <!--
                                        <span v-if="type === 'definingSkills'" class="skill_tag_row">
                                          <span class="tag ace_sec_txt" :class="type">D</span> Defining Skill
                                        </span>
                                        <span v-if="type === 'necessarySkills'" class="skill_tag_row">
                                          <span class="tag ace_sec_txt" :class="type">N</span> Necessary Skill
                                        </span>
                                        <span v-if="type === 'distinguishingSkills'" class="skill_tag_row">
                                          <span class="tag ace_sec_txt" :class="type">Dis</span> Distinguishing Skill
                                        </span>
                                        -->
                                      <span v-if="type === 'specializedSkills'" class="skill_tag_row">
                                      <span class="tag ace_sec_txt" :class="type">S</span> Specialized Skill
                                      </span>
                                      <span v-if="type === 'salaryBoostSkills'" class="skill_tag_row">
                                      <span class="tag ace_sec_txt" :class="type">$</span> Salary Boost Skill
                                      </span>
                                    </template>
                                  </div>
                                  <div class="tooltip_row" v-if="isBGTFeatureEnabled && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== 'null' && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== null && topSkillsItems.Marginal_Value !== ''">
                                    $<span v-html="addCommaInNumber(topSkillsItems.Marginal_Value)"></span>/Year
                                  </div>
                                </b-popover>
                                <div id="skillsToolTip" class="chart_tooltip_popover"></div>
                                <div class="bar_block_inner" :id="'popoverTarget2_' + index">
                                  <div class="row">
                                    <div class="col-8 bar_title">{{ topSkillsItems.Skill }} </div>
                                    <div class="col-4 bar_val_1 val_postings" style="text-align: right;">
                                      Postings <span v-html="formatNumericVal(topSkillsItems.Postings_with_Skill)"></span>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-6 tag_skill">
                                      <template v-for="type in topSkillsItems.Types">
                                        <span class="tag ace_sec_txt" :class="type" :title="'Foundational Skill'" v-if="type === 'baselineSkills'">F</span>
                                        <!--<span class="tag ace_sec_txt" :class="type" :title="'Defining Skill'" v-if="type === 'definingSkills'">D</span>
                                          <span class="tag ace_sec_txt" :class="type" :title="'Necessary Skill'" v-if="type === 'necessarySkills'">N</span>
                                          <span class="tag ace_sec_txt" :class="type" :title="'Distinguishing Skill'" v-if="type === 'distinguishingSkills'">Dis</span> -->
                                        <span class="tag ace_sec_txt" :class="type" :title="'Specialized Skill'" v-if="type === 'specializedSkills'">S</span>
                                        <span class="tag ace_sec_txt" :class="type" :title="'Salary Boost Skill'" v-if="type === 'salaryBoostSkills'" :id="setSkillRowClass(type)">$</span>
                                      </template>
                                    </div>
                                    <div class="col-6 bar_val_1 val_salary_boost" v-if="isBGTFeatureEnabled && topSkillsItems.Marginal_Value !== 'null' && topSkillsItems.Marginal_Value !== null && topSkillsItems.Marginal_Value && topSkillsItems.Marginal_Value !== ''" style="text-align: right;">
                                      $
                                      <div v-html="addCommaInNumber(topSkillsItems.Marginal_Value)" style="display: inline;"></div>
                                      /Year
                                    </div>
                                  </div>
                                </div>
                                <div class="bar" v-bind:style="{width:setSkillsBarWidth(topSkillsItems.Postings_with_Skill)}"></div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- .tab_content -->
              </div>
              <!-- .tab_content_container -->
            </div>
            <!-- .tab_content_section -->
            <div class="data_source_info" v-if="isBGTFeatureEnabled && !isWidget">Data Source: Burning Glass Technologies.</div>
          </b-card>
        </div>
      </div>

      <div class="unlock_btn_container">
        <b-button v-if="isWidget && !unlockCompaniesSkillsOnWidget && (isBGTFeatureEnabled || isEMSIFeatureEnabled)" size="lg" @click="showNewFormPopup('showAtBottom')" aria-label="verify">
          <span class="ic-lock"></span>
          <span class="btn_txt">click to unlock more details</span>
        </b-button>
      </div>

    </div>
    <!-- pg_sec -->
    <!--
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_rgt_panel content_tp_panel">
      <template v-if="programGuide && programGuide.title">
        <program-guide-summary></program-guide-summary>
      </template>
    </div>
    -->

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF; overflow: hidden;">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>
    <div class="modal_popup_container">
      <b-modal id="userVerificationPopup" ref="newFormModal" centered hide-footer class="pragya_modal usr_verification_popup" no-close-on-backdrop>
        <div slot="modal-header" class="pragya_modal_header header-section">
          <div class="head_txt">
            Unlock Company and Skills Data
          </div>
          <div class="btn_container">
            <button class="btn_close" aria-label="close" @click="closeModalBox">
            <span class="ic8-close2"></span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-1 lft_col"></div>
          <div class="col-10 content_col" @keydown.enter="login">
            <p v-if="newProspectError" class="text-danger">{{newProspectError}}</p>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="eMail">Email <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="email" v-model.email="newForm.eMail"  placeholder="Email">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="firstName">First Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.firstName" placeholder="First Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12">
                <div class="fld-label" id="lastName">Last Name <sup>*</sup></div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.lastName" placeholder="Last Name">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="showPhoneNumberOnWidgetIsEnabled">
              <div class="col-12">
                <div class="fld-label" id="primaryPhoneNumber">Phone Number</div>
              </div>
              <div class="col-12">
                <b-form-input type="text" v-model.trim="newForm.primaryPhoneNumber" placeholder="Phone Number">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="showTermOnWidgetIsEnabled">
              <div class="col-12">
                <div class="fld-label term-fld-label" id="selectedTerm">Terms</div>
              </div>
              <div class="col-12">
                <b-form-select v-model="newForm.selectedTerm" :options="availableTerms" :disabled="(availableTerms.length === 0)"></b-form-select>
              </div>
            </div>
            <div class="row popup_btn_container">
              <div class="col-6 pragya_login_lnk">
                <a :href="loginUrl" target="_blank">I already have a login</a>
              </div>
              <div class="col-6 popup_btn">
                <b-button size="lg" @click="registerProspectiveStudent()" :disabled="!isUnlockEnabled" aria-label="verify">unlock details</b-button>
              </div>
            </div>
          </div>
          <div class="col-1 rgt_col"></div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal ref="noResultReturnedModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
        <div class="d-block text-center">
          <h5>Career search returned zero results.</h5>
        </div>
        <div class="text-center mt-4">
          <b-button size="sm" @click="closeNoResultModal" style="background: #98002e!important;">Close</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import BarChart from './BarChart'
  import DoughnutChart from './DoughnutChart'
  import ScatterChart from './ScatterChart'
  import TreeMapChart from './TreeMapChart'

  export default {
    name: 'program-guide-career-prospects-detail',
    props: ['cipCode', 'programGuideCode', 'isShowLess', 'isWidget', 'institutionId', 'majorTitle'],
    components: {
      BarChart,
      DoughnutChart,
      ScatterChart,
      TreeMapChart
    },
    data: () => {
      return {
        RECOMMENDATION_TERM_LIMIT: 5,
        selectedState: '',
        selectedMetroArea: '',
        selectedCounty: '',
        careerMinIncome: '',
        careerMaxIncome: '',
        disableSelectState: false,
        disableSelectMetroArea: false,
        disableSelectCounty: false,
        showSkillTagLegends: false,
        isSalaryBoostSkill: false,
        targetOccupationItems: [],
        topCompaniesItems: [],
        topSkillsFields: ['Skill', 'Postings_with_Skill'],
        topSkillsItems: [],
        growthPieOptions: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        },
        newForm: {
          eMail: '',
          firstName: '',
          lastName: '',
          major1: '',
          major1CipCode: '',
          major1Title: '',
          primaryPhoneNumber: '',
          selectedTerm: null
        },
        loginUrl: window.location.origin,
        newProspectError: '',
        isCareerGraphExpanded: false,
        selectedDataInfo: 'US'
      }
    },

    async mounted () {
      this.resetData()
      await this.loadDataForProgramGuideCareerProspects()
    },

    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadProgramGuideCareers',
        'loadProgramCareerResult',
        'loadAlumniStreamRecommendations',
        'loadAdvisorStreamRecommendations',
        'resetProgramCareerResult',
        'loadGeoIds',
        'loadRegisterProspectiveStudent',
        'loadLogDashboardActivity',
        'updateShowAllOccupations'
      ]),
      async registerProspectiveStudent () {
        this.newProspectError = ''
        this.newForm.major1 = this.programGuideCode
        this.newForm.major1CipCode = this.cipCode
        this.newForm.major1Title = this.majorTitle
        let institutionId = this.institutionId
        if (this.newForm.eMail.length < 5) {
          this.newProspectError = 'Please enter a valid email.'
        } else if (this.newForm.firstName.length < 1 || this.newForm.lastName.length < 1) {
          this.newProspectError = 'First Name and Last Name are required.'
        } else {
          this.$refs.loadingModal.show()
          this.loadLogDashboardActivity({action: 'submitProspectiveStudentForm', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
          let response = await this.loadRegisterProspectiveStudent({prospectiveStudentForm: this.newForm, learningSpaceId: institutionId})
          if (response && response.data === 'duplicate_email_value') {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Email already exists!'
            })
            this.newProspectError = 'Email already exists. Please click on login.'
            this.newForm = {
              eMail: '',
              firstName: '',
              lastName: '',
              major1: '',
              major1CipCode: '',
              major1Title: '',
              selectedTerm: null
            }
          } else if (response && response.status === 200) {
            let verifyUrl = window.location.origin + '/vue/#/verify?email=' + this.newForm.eMail
            window.open(verifyUrl, '_blank')
            this.$refs.newFormModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Please check your email for instructions!'
            })
            this.newForm = {
              eMail: '',
              firstName: '',
              lastName: '',
              major1: '',
              major1CipCode: '',
              major1Title: '',
              selectedTerm: null
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Error! Please try again!'
            })
          }
          this.$refs.loadingModal.hide()
        }
      },
      toggleShowOccupations () {
        this.updateShowAllOccupations(!this.showAllOccupations)
      },
      getRandomInt (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min)
      },
      callDrawNeedle (el, value) {
        if (!document || !document.getElementById(el)) return
        let canvas = document.getElementById(el).childNodes[1]
        if (canvas) {
          if (value && value < -10) {
            this.drawNeedle(canvas, 50, -170 * Math.PI / 180)
          } else if (value && value >= -10 && value < -5) {
            this.drawNeedle(canvas, 50, -150 * Math.PI / 180)
          } if (value && value >= -5 && value < 0) {
            this.drawNeedle(canvas, 50, -130 * Math.PI / 180)
          } else if (value && value >= 0 && value < 5) {
            if (value === '0.0') {
              this.drawNeedle(canvas, 50, -125 * Math.PI / 180)
            } else {
              this.drawNeedle(canvas, 50, -110 * Math.PI / 180)
            }
          } else if (value && value >= 5 && value < 10) {
            this.drawNeedle(canvas, 50, -90 * Math.PI / 180)
          } else if (value && value >= 10 && value < 15) {
            this.drawNeedle(canvas, 50, -70 * Math.PI / 180)
          } else if (value && value >= 15 && value < 20) {
            this.drawNeedle(canvas, 50, -50 * Math.PI / 180)
          } else if (value && value >= 20 && value < 25) {
            this.drawNeedle(canvas, 50, -30 * Math.PI / 180)
          } else if (value && value >= 25) {
            this.drawNeedle(canvas, 50, -10 * Math.PI / 180)
          }
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -5)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 5)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 7, 0, Math.PI * 2)
        ctx.fill()
      },
      async loadDataForProgramGuideCareerProspects () {
        // load related career information, if any exists
        if (this.isWidget) {
          await this.loadProgramGuideCareers({ cipCode: this.cipCode, code: this.programGuideCode, showAllOccupations: this.showAllOccupations })
          await this.loadGeoIds()
        }
      },
      getLocationParamForCareerSearch () {
        let locationParam = ''
        let selectedState = (this.selectedState && this.selectedState.label) ? this.selectedState.label : ''
        let selectedMetroArea = (this.selectedMetroArea && this.selectedMetroArea.label) ? this.selectedMetroArea.label : ''
        let selectedCounty = (this.selectedCounty && this.selectedCounty.label) ? this.selectedCounty.label : ''

        if (selectedState) {
          locationParam = 'state:' + this.labelsToCodesMap.stateGeoIds[selectedState]
        } else if (selectedMetroArea) {
          locationParam = 'msa:' + this.labelsToCodesMap.msaGeoIds[selectedMetroArea]
        } else if (selectedCounty) {
          locationParam = 'county:' + this.labelsToCodesMap.countyGeoIds[selectedCounty]
        }
        return locationParam
      },
      showFloatingFilterSection () {
        $('.fix_pg_tabs .filters_section').css('display', 'block')
      },
      hideFloatingFilterSection () {
        $('.fix_pg_tabs .filters_section').css('display', 'none')
      },
      showSalaryBoostSkills () {
        $('#careerDetailsSkills').addClass('show_boost_skills_only')
      },
      showAllSkills () {
        $('#careerDetailsSkills').removeClass('show_boost_skills_only')
      },
      closeNoResultModal () {
        this.selectedState = ''
        this.selectedMetroArea = ''
        this.$refs.noResultReturnedModal.hide()
      },
      careerSearchClicked () {
        let cipCode = this.formattedCareer.cipCode
        let programCode = this.formattedCareer.code
        let locationParam = this.getLocationParamForCareerSearch()

        if (!locationParam || !cipCode) {
          return
        }

        this.$refs.loadingModal.show()
        this.loadProgramCareerResult({cipCode: cipCode, programCode: programCode, locationParam: locationParam}).then(response => {
          this.$refs.loadingModal.hide()
          if (!response) {
            this.$notify({
              group: 'notify',
              type: 'warning',
              title: '',
              text: 'Career search returned zero results.'
            })
            if (this.isWidget) {
              this.$refs.noResultReturnedModal.show()
            }
          }
          if (this.selectedCounty) {
            this.selectedDataInfo = this.selectedCounty.label
          } else if (this.selectedState) {
            this.selectedDataInfo = this.selectedState.label
          } else if (this.selectedMetroArea) {
            this.selectedDataInfo = this.selectedMetroArea.label
          } else {
            this.selectedDataInfo = 'US'
          }
          this.$forceUpdate()
        })
        this.loadLogDashboardActivity({action: 'filterByCityOrState', page: 'programCareerProspects', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
      },
      checkForCompanyName (companyName) {
        if (companyName === '[Unknown]') {
          return 'Others'
        }
        return companyName
      },
      addCommaInNumber (numValue) {
        if (numValue && numValue.length > 0) {
          let numericValue = Math.floor(numValue)
          return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return numValue
      },
      setSkillRowClass (skillType) {
        if (skillType === 'salaryBoostSkills') {
          this.isSalaryBoostSkill = true
        } else {
          this.isSalaryBoostSkill = false
        }
      },
      formatNumericVal (numValue) {
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      setIncomeBarWidth (numValue) {
        return ((numValue / (this.formattedCareer.aggregatedMedianHourlyEarning * 2)) * 100) + '%'
      },
      setSkillsBarWidth (postings) {
        return ((postings / (this.formattedCareer.aggregatedLastYearJob)) * 100) + '%'
      },
      formatOptionsForVSelect (map) {
        let formatted = []
        Object.keys(map).sort().forEach((key, i) => {
          formatted.push({id: key, label: map[key]})
        })
        formatted.sort((a, b) => (a.label >= b.label) ? 1 : -1)
        return formatted
      },
      setDotMargin (positionValue) {
        let getContainerWidth = $('.custom_dot_gph_container').width()
        let getXPosition = (positionValue - 20000) / (getContainerWidth / 2)
        return getXPosition + 'px'
      },
      setMinIncome () {
        let formatted = []
        this.formattedCareers.forEach((career) => {
          formatted.push(career.medianHourlyEarning)
        })
        let minIncome = Math.min.apply(Math, formatted)
        let maxIncome = Math.max.apply(Math, formatted)
        let incomeDiff = 3000
        this.careerMinIncome = Math.round((minIncome - incomeDiff) / 1000) * 1000
        this.careerMaxIncome = Math.ceil((maxIncome + incomeDiff) / 1000) * 1000
        return (Math.round((minIncome - incomeDiff) / 1000) * 1000).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      resetData () {
        // this ensures the original program guide object info binds to the ui
        this.targetOccupationItems = []
        this.topCompaniesItems = []
        this.topSkillsItems = []
        this.resetProgramCareerResult()
        if (!this.disableSelectState && !this.disableSelectMetroArea) {
          this.selectedDataInfo = 'US'
        }
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      hasLaborData (career) {
        if (!career) {
          return false
        }
        return career.targetOccupations || career.topPostingCompanies || career.topSkills
      },
      showNewFormPopup (popupPosition) {
        this.loadLogDashboardActivity({action: 'unlockCompaniesSkills', page: 'programCareerProspectsWidget', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
        this.$refs.newFormModal.show()
        $('.usr_verification_popup').removeClass('showAtTop')
        $('.usr_verification_popup').removeClass('showAtBottom')
        $('.usr_verification_popup').addClass(popupPosition)
      },
      showTabContent (tabId, tabPanelId) {
        this.loadLogDashboardActivity({action: 'companiesOrSkillsTabClicked', page: 'programCareerProspects', link: '', programCipCode: this.cipCode, programCode: this.programGuideCode})
        $('.tab_content').removeClass('active')
        $('#' + tabPanelId).addClass('active')
        $('.tabs .nav-link').removeClass('active')
        $('#' + tabId).addClass('active')
      },
      closeModalBox () {
        this.$root.$emit('bv::hide::modal', 'userVerificationPopup')
        this.$parent.isShowTagPopup = false
        this.newForm = {
          eMail: '',
          firstName: '',
          lastName: '',
          major1: '',
          major1CipCode: '',
          major1Title: '',
          selectedTerm: null
        }
      },
      closeSkillTagsLegendsPopup () {
        this.$refs.skillTagsLegendsPopover.$emit('close')
      },
      closeEducationLevelTagsLegendsPopup () {
        this.$refs.educationLevelTagsLagends.$emit('close')
      },
      navigateToCareer (career) {
        if (!this.isWidget) {
          if (!career.code) {
            this.$notify({
              group: 'notify',
              type: 'warning',
              title: '',
              text: 'Career does not exist.'
            })
          } else {
            let routerParams = {
              code: career.pragyaSoc,
              cipCode: this.cipCode,
              programCode: this.programGuideCode,
              returnTo: 'programGuideCareers',
              showBackToResultButton: false
            }
            return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'programGuideCareers'} })
          }
        }
      },
      getClassOf (person) {
        if (person.educationInfoList && person.educationInfoList.length > 0) {
          return ' - Class of ' + person.educationInfoList[0].classOf
        }
        return ''
      },
      navigateToSpotlightAlumni () {
        let routerParams = {
          cipCode: this.$parent.cipCode,
          programGuideCode: this.$parent.programGuideCode,
          type: this.$parent.type,
          returnTo: this.$parent.returnTo || 'exploreProgramGuideResults',
          showBackToResultButton: true,
          isWidget: this.$parent.isWidget,
          selected: this.$parent.selected
        }
        let queryParam = {
          returnTo: this.$route.query.returnTo || 'exploreProgramGuideResults'
        }
        return this.$router.push({name: 'programGuideSpotlightAlumni', params: routerParams, query: queryParam})
      },
      getMoreLessLabel () {
        let label = ''
        if ($('#biography').hasClass('description')) {
          label = 'more'
        } else {
          label = 'less'
        }
        return label
      },
      expandCollapseBio () {
        $('#biography').toggleClass('description')
        if ($('#biography').hasClass('description')) {
          $('#more-less').text('more')
        } else {
          $('#more-less').text('less')
        }
      }
    },
    computed: {
      ...mapState({
        'programGuide': state => state.programguide.programGuideObject,
        'alumniData': state => state.programguide.programAlumniData,
        'showAllOccupations': state => state.programguide.showAllOccupations,
        'careersObject': state => state.programguide.careers,
        'careerResult': state => state.programguide.careerResult,
        'packages': state => state.institution.packages,
        'geoIdMap': state => state.career.geoIdMap,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'termMapWithCutOffDate': state => state.institution.termMapWithCutOffDate
      }),
      isUnlockEnabled () {
        return ((this.newForm.eMail.length > 0) && (this.newForm.firstName.length > 0) && (this.newForm.lastName.length > 0))
      },
      availableTerms () {
        let terms = []
        let entries = Object.entries(this.termMapWithCutOffDate)
        if (entries && entries.length > 0) {
          terms.push({value: null, text: 'Select a Term'})
          for (const [key, data] of entries) {
            if (key) {
              terms.push({value: key, text: data.label})
            }
          }
          return terms
        }
        return []
      },
      showTermOnWidgetIsEnabled () {
        let termFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_TERM_ON_WIDGET]
        return termFeature && termFeature.enabled
      },
      showPhoneNumberOnWidgetIsEnabled () {
        let phoneNumberFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_PHONE_NUMBER_ON_WIDGET]
        return phoneNumberFeature && phoneNumberFeature.enabled
      },
      showEducationLevelOnWidgetEnabled () {
        let educationLevelOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL_ON_WIDGET]
        return educationLevelOnWidgetFeature && educationLevelOnWidgetFeature.enabled
      },
      showEducationLevelEnabled () {
        let educationLevelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_EDUCATION_LEVEL]
        return educationLevelFeature && educationLevelFeature.enabled
      },
      isEMSIFeatureEnabled () {
        let emsiFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_EMSI_SOURCE]
        return emsiFeature && emsiFeature.enabled
      },
      isBGTFeatureEnabled () {
        let bgtFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_BGT_SOURCE]
        let lightcastFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_SEARCH_LIGHTCAST_SOURCE]
        return ((bgtFeature && bgtFeature.enabled) || (lightcastFeature && lightcastFeature.enabled))
      },
      showCityStateFilterOnWidget () {
        let showCityStateFilterOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_CITY_STATE_FILTER_ON_WIDGET]
        return showCityStateFilterOnWidgetFeature && showCityStateFilterOnWidgetFeature.enabled
      },
      unlockCompaniesSkillsOnWidget () {
        let unlockCompaniesSkillsOnWidgetFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.UNLOCK_COMPANIES_SKILLS_ON_WIDGET]
        return unlockCompaniesSkillsOnWidgetFeature && unlockCompaniesSkillsOnWidgetFeature.enabled
      },
      companiesTreeMapData () {
        if (this.formattedCareer && this.formattedCareer.topPostingCompanies) {
          let jsonData = {
            name: ' ',
            children: []
          }
          /*
          this.formattedCareer.topPostingCompanies.forEach((career) => {
            let parsedCareer = JSON.parse(career)
            let careerObj = {
              name: parsedCareer.name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          })
          */
          let length = this.formattedCareer.topPostingCompanies.length
          let count = (length < 4) ? length : 4
          for (var i = 0; i < count; i++) {
            let parsedCareer = JSON.parse(this.formattedCareer.topPostingCompanies[i])
            let name = parsedCareer.name
            let value = parsedCareer.unique_postings
            if (parsedCareer.name === '[Unknown]') {
              name = 'Others'
            }
            if (parsedCareer.name === 'ACCENTURE, INC.') {
              name = 'Accenture'
            }
            if (parsedCareer.name === 'Robert Half International Inc.') {
              name = 'Robert Half'
            }
            let careerObj = {
              name: name,
              value: value
            }
            jsonData.children.push(careerObj)
          }
          return jsonData
        }
        return {}
      },
      skillsTreeMapData () {
        if (this.formattedCareer && this.formattedCareer.topSkills) {
          let jsonData = {
            name: 'Top Skills',
            children: []
          }
          /*
          this.formattedCareer.topSkills.forEach((career) => {
            let parsedCareer = JSON.parse(career)
            let careerObj = {
              name: parsedCareer.name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          })
          */
          let length = this.formattedCareer.topSkills.length
          let count = (length < 4) ? length : 4
          for (var i = 0; i < count; i++) {
            let parsedCareer = JSON.parse(this.formattedCareer.topSkills[i])
            let name = parsedCareer.name
            if (name === 'JavaScript (Programming Language)') {
              name = 'JavaScript'
            }
            if (name === 'Java (Programming Language)') {
              name = 'Java'
            }
            if (name === 'Agile Software Development') {
              name = 'Agile'
            }
            let careerObj = {
              name: name,
              value: parsedCareer.unique_postings
            }
            jsonData.children.push(careerObj)
          }
          return jsonData
        }
        return {}
      },
      incomeScatterData () {
        if (this.formattedCareers) {
          let data = {
            labels: [],
            datasets: [
              {
                label: '',
                fill: false,
                borderWidth: 0,
                borderColor: 'rgb(245, 245, 245)',
                backgroundColor: 'rgb(245, 245, 245)',
                pointRadius: 14,
                pointHoverRadius: 16,
                pointBackgroundColor: '#157099',
                pointBorderWidth: 2,
                pointBorderColor: '#014966',
                data: []
              }
            ]
          }
          this.formattedCareers.forEach((career) => {
            let dataPoint = {
              x: career.medianHourlyEarning,
              y: this.getRandomInt(0, 1)
            }
            data.datasets[0].data.push(dataPoint)
            data.labels.push(career.name)
          })
          return data
        }
        return {}
      },
      jobPostingsPieData () {
        let data = {
          // labels: ['Job Postings'],
          datasets: [
            {
              label: 'Job Postings',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedLastYearJob) {
          data.datasets[0].data.push(this.formattedCareer.aggregatedLastYearJob)
        }
        return data
      },
      growthPieData () {
        let data = {
          // labels: ['Less than 0%', '0-15%', 'Greater than 15%'],
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedGrowthPercentage) {
          return data
        }
        return {}
      },
      medianIncomePieData () {
        let data = {
          // labels: ['Median Income'],
          datasets: [
            {
              label: 'Median Income',
              backgroundColor: '#8db350',
              data: []
            }
          ]
        }
        if (this.formattedCareer && this.formattedCareer.aggregatedMedianHourlyEarning) {
          data.datasets[0].data.push(this.formattedCareer.aggregatedMedianHourlyEarning)
        }
        return data
      },
      formattedCareers () {
        let formattedCareers = []
        let careers = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!this.hasLaborData(careers)) {
          return []
        }
        // this.resetData()
        careers.targetOccupations.forEach((career) => {
          formattedCareers.push(JSON.parse(career))
        })

        formattedCareers = formattedCareers.sort((a, b) => (parseFloat(a.medianHourlyEarning) <= parseFloat(b.medianHourlyEarning)) ? 1 : -1)
        return formattedCareers
      },
      formattedCareer () {
        let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
        if (!this.hasLaborData(formattedCareer)) {
          return {}
        }
        this.resetData()
        formattedCareer.targetOccupations.forEach((career, i) => {
          let curr = JSON.parse(career)
          if (i === 0) {
            formattedCareer.timeframe = curr.timeframe
            formattedCareer.endYear = curr.year
            formattedCareer.startYear = formattedCareer.endYear - 10
            formattedCareer.tenYearOldJobTitle = curr.tenYearOldJobTitle
          }
          let tenYearOldJobTitle = formattedCareer.tenYearOldJobTitle
          let growthTitle = 'Growth (' + formattedCareer.timeframe + ')'
          let currItem = {
            'Occupation': curr.name,
            'Annual Openings': curr.annualOpening,
            'Median Earnings': curr.medianHourlyEarning,
            'Education': curr.education,
            'code': curr.code,
            'growth': curr.growth,
            'timeframe': curr.timeframe,
            'aggregatedMaxIncome': curr.maxIncome,
            'aggregatedMinIncome': curr.minIncome,
            'pragyaSoc': curr.pragyaSoc
          }
          currItem[tenYearOldJobTitle] = curr.tenYearOldJob
          currItem[growthTitle] = curr.growth
          // if (parseFloat(curr.growth) > 10) {
          this.targetOccupationItems.push(currItem)
          // }
        })
        // DO not sort if disable
        if (!formattedCareer.disableCareerSort) {
          this.targetOccupationItems = this.targetOccupationItems.sort((a, b) => (parseFloat(a['Median Earnings']) <= parseFloat(b['Median Earnings'])) ? 1 : -1)
        }

        if (!formattedCareer.topPostingCompanies) {
          return formattedCareer
        }

        formattedCareer.topPostingCompanies.forEach((company, i) => {
          let curr = JSON.parse(company)
          let tenYearPostingTitle = 'Total/Unique (' + formattedCareer.timeframe + ')'
          let currItem = {'Company': curr.name}
          currItem[tenYearPostingTitle] = curr.total_postings + ' / ' + curr.unique_postings
          currItem['Total'] = curr.total_postings
          currItem['Unique'] = curr.unique_postings
          currItem['Posting Intensity'] = (Math.round(curr.posting_intensity)) + ':1'
          this.topCompaniesItems.push(currItem)
        })
        this.topCompaniesItems = this.topCompaniesItems.sort((a, b) => (Number(a.Total) <= Number(b.Total)) ? 1 : -1)
        if (!formattedCareer.topSkills) {
          return formattedCareer
        }

        formattedCareer.topSkills.forEach((skill, i) => {
          let curr = JSON.parse(skill)
          let currItem = {'Skill': curr.name,
            'Postings_with_Skill': curr.unique_postings,
            'Types': curr.types,
            'Marginal_Value': curr.marginal_value }
          this.topSkillsItems.push(currItem)
        })
        this.topSkillsItems = this.topSkillsItems.sort((a, b) => (Number(a.Postings_with_Skill) <= Number(b.Postings_with_Skill)) ? 1 : -1)
        return formattedCareer
      },
      formattedGeoIdMap () {
        let formattedMap = {}
        let map = this.geoIdMap

        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = this.formatOptionsForVSelect(map.stateGeoIds)
          formattedMap.msaGeoIds = this.formatOptionsForVSelect(map.msaGeoIds)
          formattedMap.countyGeoIds = this.formatOptionsForVSelect(map.countyGeoIds)
        }
        return formattedMap
      },
      labelsToCodesMap () {
        let map = this.geoIdMap
        let formattedMap = {}
        if (map.stateGeoIds && map.msaGeoIds && map.countyGeoIds) {
          formattedMap.stateGeoIds = _.invert(map.stateGeoIds)
          formattedMap.msaGeoIds = _.invert(map.msaGeoIds)
          formattedMap.countyGeoIds = _.invert(map.countyGeoIds)
        }
        return formattedMap
      },
      targetOccupationFields () {
        let fields = ['Occupation']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push((curr.tenYearOldJobTitle))
          fields.push('Annual Openings')
          fields.push('Median Earnings')
          fields.push('Growth (' + curr.timeframe + ')')
          return fields
        } else {
          return []
        }
      },
      topCompaniesFields () {
        let fields = ['Company']
        if (this.formattedCareer.targetOccupations && this.formattedCareer.targetOccupations.length > 0) {
          let curr = JSON.parse(this.formattedCareer.targetOccupations[0])
          fields.push('Total/Unique (' + curr.timeframe + ')')
          fields.push('Posting Intensity')
          return fields
        } else {
          return []
        }
      },
      exploreProgramDetailFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
        let exploreSearchPackage = this.getExploreSearchPackage
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getExploreSearchPackage(packages)
      },
      showAlumniData () {
        let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
        if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.showAlumniData) {
          return false
        }
        return this.alumniData && exploreProgramDetailFlagMap.showAlumniData.enabled
      },
      showCareerEmoloyerJob () {
        return this.alumniData && (this.alumniData.topCareerTitle || this.alumniData.topCompanyTitle || this.alumniData.totalHireLastYearHire)
      },
      spotlightAlumni () {
        if (this.alumniData.spotlightPerson && this.alumniData.spotlightPerson.length > 0) {
          return this.alumniData.spotlightPerson[0]
        }
        return null
      }
    },
    watch: {
      selectedState (newState) {
        if (!newState) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
          this.resetData()
          this.loadDataForProgramGuideCareerProspects()
          this.isSalaryBoostSkill = false
        } else {
          this.disableSelectState = false
          this.disableSelectMetroArea = true
          this.disableSelectCounty = true
        }
      },
      selectedMetroArea (newMSA) {
        if (!newMSA) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
          this.resetData()
          this.loadDataForProgramGuideCareerProspects()
          this.isSalaryBoostSkill = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = false
          this.disableSelectCounty = true
        }
      },
      selectedCounty (newCounty) {
        if (!newCounty) {
          this.disableSelectState = false
          this.disableSelectMetroArea = false
          this.disableSelectCounty = false
        } else {
          this.disableSelectState = true
          this.disableSelectMetroArea = true
          this.disableSelectCounty = false
        }
      }
    }
  }
</script>
<style scoped>
  .frm_btn_col .btn {
    margin-top: 32px;
    height: 40px;
  }
  .state .v-select .dropdown-toggle {
    background-color: #d0eaf4;
  }
  .city .v-select .dropdown-toggle {
    background-color: #ffebed;
  }
  .term-fld-label {
    text-align: left;
    margin-bottom: .5rem;
    font-size: 1.15rem;
    color: #323232;
    padding-left: .3rem;
  }
</style>



// WEBPACK FOOTER //
// widgetSrc/app/programguide/components/ProgramGuideCareerProspectsDetail.vue